(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselContainers = document.querySelector('.collection-swiper-container');
    const container = carouselContainers.querySelector('.swiper');
    const buttons = carouselContainers.querySelectorAll('.swiper-button-prev, .swiper-button-next');
    const nextButton = carouselContainers.querySelector('.swiper-button-next');

    if (!container || !buttons) return;


    // Add click event listener to next button
    buttons.forEach(button => {
      button.addEventListener('click', function() {
      setTimeout(() => {
      if (nextButton.classList.contains('disabled')) {
     
        container.classList.add('swiper-background-hidden');
      } else {
       
        container.classList.remove('swiper-background-hidden');
      }
    }, 300);
    }); 
  }); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var MOBILE_MAX_WIDTH = 768;
  var adspace = document.querySelector('.product-adspace-block-wrapper');
  if (!adspace) return;

  // Capture the original DOM location so we can restore it when the viewport widens.
  var originalParent = adspace.parentElement;
  var originalNextSibling = adspace.nextElementSibling;

  function syncAdspacePlacement() {
    var media = document.querySelector('.product-information__grid');
    if (!media) return;

    var isMobile = window.innerWidth <= MOBILE_MAX_WIDTH;

    if (isMobile) {
      if (adspace.parentElement !== media.parentElement || adspace.nextElementSibling !== media) {
        media.parentElement.insertBefore(adspace, media);
      }
    } else {
      if (adspace.parentElement !== originalParent || adspace.nextElementSibling !== originalNextSibling) {
        originalParent.insertBefore(adspace, originalNextSibling);
      }
    }
  }

  syncAdspacePlacement();
  window.addEventListener('resize', syncAdspacePlacement);
});


  } catch(e) { console.error(e); }
})();
})();
